import { Slide } from "react-slideshow-image";

import "react-slideshow-image/dist/styles.css";
import "../styles/Slider.css";

export default function Slider({ mediaArray }) {
  return (
    <div className="container">
      <Slide easing="ease" autoplay={false}>
        {mediaArray.map((media, index) => (
          <div className="slide" key={index}>
            {/* Render an image or video depending on the media type */}
            {media.type === "image" ? (
              <img src={media.src} style={{ width: "100%" }} />
            ) : (
              <video src={media.src} controls style={{ width: "100%" }}>
                <source type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        ))}
      </Slide>
    </div>
  );
}
